<!--Title-->
<h3>{{'_General_Checklists_Text_' | translate }}</h3>

<div class="cc-content-wrapper">
  <!--Action Panel-->
  <div class="cc-action-panel row">
    <!--Filters-->
    <div class="cc-filters">
      <div>
        <label>{{'_General_Product_Category_Text_' | translate }}</label>
        <select (change)="onProductCategoryChanged()" [(ngModel)]="selectedCategory"
          class="cc-select-dropdown form-control">
          <option *ngFor="let productCategory of productCategories; trackBy: psTrackBy" [ngValue]="productCategory">
            {{productCategory.productCategoryDisplayName}}</option>
        </select>
      </div>
    </div>

    <!--Search with close-->
    <div class="cc-search with-close">
      <input id="kioskConfigSearchText" type="text" placeholder="{{'_General_Search_Text_' | translate }}"  class="form-control" [(ngModel)]="searchText"
        (keyup)="searchKeyWordChange($event)" />
      <button id="kioskConfigSearchButton" type="button" class="cc-search-btn"
        (click)="searchProductCategoryOrService()"><span class="fas fa-search"></span></button>
      <button type="button" [ngClass]="{'show-btn': showClearButton}" (click)="onClearSearchTextClicked()"
        class="cc-close-btn"><span class="fas fa-times"></span></button>
    </div>
  </div>
  <!--User Grid-->
  <div class="localization-checklists-permission-clients-grid-wrapper-grid-wrapper">
    <kendo-grid  [data]="data" [pageSize]="pageSize" [skip]="skip" [pageable]="true"
      scrollable="scrollable" (sortChange)="onSortChange($event)" (pageChange)="onPageChange($event)"
      [sortable]="{allowUnsort: false, mode: 'single'}"
      (remove)="removeChecklist($event)" [sort]="sort">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>

      <kendo-grid-column field="serviceName" title="{{'_Checklists_Product/Service_Column_Title_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{'font-weight' : 'bold'}" >
      </kendo-grid-column>
      <kendo-grid-column field="productCategoryName" title="{{'_General_Product_Category_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{'font-weight' : 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="checklistItemCount" [width]="220" title="{{'_Checklists_NumberOf_Checklist_Items_Column_Title_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{'font-weight' : 'bold'}">
      </kendo-grid-column>
      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}" *ngIf="(userPermissionList?.includes(50)) || (userPermissionList?.includes(51)) || (userPermissionList?.includes(52))">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell-items-center">
          <button *ngIf="dataItem.checklistItemCount === 0 && userPermissionList?.includes(50)" class="cc-icon-btn" title="{{'_General_Button_Add_Text_' | translate }}"
            (click)="onChecklistAddOrEdit(dataItem)"><span class="fas fa-plus"></span></button>
          <button *ngIf="dataItem.checklistItemCount > 0 && userPermissionList?.includes(51)" class="cc-icon-btn" title="{{'_General_Button_Edit_Text_' | translate }}"
            (click)="onChecklistAddOrEdit(dataItem)"><span class="fas fa-pen"></span></button>
          <button *ngIf="dataItem.checklistItemCount > 0  && userPermissionList?.includes(52)" class="cc-icon-btn" title="{{'_General_Button_Delete_Text_' | translate }}"
            (click)="removeChecklist(dataItem)"><span class="fas fa-trash-alt"></span></button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div> 

<app-modalpopup header="{{'_Checklist_Delete_Popup_Header_Text_'| translate}}" [(dialogOpened)]="opened" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}"
  actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}" 
  message="{{'_Checklist_Delete_Popup_Confirm_Message_Text_' | translate}}  {{serviceToRemoveChecklist.serviceName}}?"
  (submitted)="close('Yes')" (cancelled)="close('No')">
</app-modalpopup>
